import { FC } from "react";

import { ROUTES } from "constants/routes";

import Burger from "icons/Burger";
import Logo from "icons/Logo";

import {
  StyledMobileHeader,
  StyledMobileHeaderBurgerBtn,
  StyledMobileHeaderLogo,
} from "styles/components/mobile-header";

interface MobileHeaderProps {
  onClick?: () => void;
}

const MobileHeader: FC<MobileHeaderProps> = ({ onClick }) => (
  <StyledMobileHeader>
    <StyledMobileHeaderLogo to={ROUTES.home}>
      <Logo id="mobile-logo" />
    </StyledMobileHeaderLogo>
    <StyledMobileHeaderBurgerBtn onClick={onClick}>
      <Burger />
    </StyledMobileHeaderBurgerBtn>
  </StyledMobileHeader>
);

export default MobileHeader;
